// Mock data for PULVISTAR website

export const services = [
  {
    id: 'toitures',
    title: 'Nettoyage de toitures',
    slug: 'toitures',
    description: 'Redonnez à votre toiture son aspect d\'origine grâce à notre technologie de démoussage par drone. Sans échafaudage ni nacelle, nous éliminons mousses, lichens et salissures incrustées tout en préservant l\'intégrité de vos matériaux. Une toiture propre, c\'est une toiture qui dure plus longtemps et qui protège mieux votre bâtiment.',
    icon: 'Home',
    image: 'https://customer-assets.emergentagent.com/job_eco-drone-1/artifacts/lwpn2715_Drone%20nettoyant%20le%20toit%20d%27une%20maison.png',
    benefits: [
      'Prolonge la durée de vie de votre toiture de 10 à 15 ans',
      'Aucun échafaudage : intervention rapide et sans risque pour votre structure',
      'Traitement personnalisé selon le type de couverture (tuiles, ardoises, zinc, fibrociment)',
      'Prévention des infiltrations grâce à la pose d\'un traitement hydrofuge protecteur',
      'Application d\'un traitement anti-mousse longue durée après nettoyage',
      'Rapport photographique avant/après fourni systématiquement'
    ],
    process: [
      'Inspection par drone avec capteurs HD pour cartographier l\'état de la toiture',
      'Analyse du type de couverture et calibrage de la pression de pulvérisation',
      'Nettoyage par pulvérisation haute pression adaptée et traitement anti-mousse',
      'Contrôle qualité final et remise du rapport d\'intervention complet'
    ]
  },
  {
    id: 'panneaux-solaires',
    title: 'Nettoyage de panneaux solaires',
    slug: 'panneaux-solaires',
    description: 'Un panneau solaire encrassé peut perdre jusqu\'à 30% de son rendement. Notre service de nettoyage par drone restaure la performance optimale de vos installations photovoltaïques sans interrompre la production. Une solution rentable qui s\'autofinance par le gain de rendement énergétique.',
    icon: 'Sun',
    image: 'https://customer-assets.emergentagent.com/job_eco-drone-1/artifacts/1bg3nm0r_panneau%20solaire.png',
    benefits: [
      'Récupération de rendement de 15 à 30% après nettoyage',
      'Zéro coupure de production : intervention en fonctionnement',
      'Eau déminéralisée uniquement, aucun produit chimique agressif',
      'Conformité totale aux garanties constructeurs (SunPower, Enphase, etc.)',
      'Fréquence recommandée : 1 à 2 fois par an selon l\'environnement',
      'Idéal pour les parcs solaires, toitures agricoles et industrielles'
    ],
    process: [
      'Diagnostic de performance : mesure du rendement actuel de vos panneaux',
      'Nettoyage doux par drone avec eau déminéralisée, sans abrasion ni pression excessive',
      'Rinçage complet et séchage naturel pour éviter les traces de calcaire',
      'Mesure comparative du gain de rendement et remise du rapport technique'
    ]
  },
  {
    id: 'eoliennes',
    title: 'Nettoyage d\'éoliennes',
    slug: 'eoliennes',
    description: 'Les pales d\'éoliennes accumulent insectes, poussières et résidus atmosphériques qui affectent leur aérodynamisme et réduisent la production d\'énergie. Notre intervention par drone élimine ces dépôts à haute altitude sans mobiliser de nacelle, réduisant considérablement les coûts et les temps d\'arrêt.',
    icon: 'Wind',
    image: 'https://customer-assets.emergentagent.com/job_eco-drone-1/artifacts/xfj2ea2x_eolienne.jpg',
    benefits: [
      'Restauration de l\'aérodynamisme optimal des pales',
      'Accès jusqu\'à 150 mètres de hauteur sans nacelle ni cordiste',
      'Réduction des temps d\'arrêt de 70% par rapport aux méthodes traditionnelles',
      'Intervention sécurisée : aucun risque humain en hauteur',
      'Détection précoce des micro-fissures et dommages structurels',
      'Planning flexible adapté aux conditions météorologiques'
    ],
    process: [
      'Planification selon les prévisions météo et coordination avec l\'exploitant',
      'Inspection visuelle haute résolution de chaque pale par drone',
      'Nettoyage haute précision avec pression calibrée pour ne pas endommager le revêtement',
      'Rapport d\'intervention détaillé avec cartographie des zones traitées'
    ]
  },
  {
    id: 'monuments-historiques',
    title: 'Monuments historiques',
    slug: 'monuments-historiques',
    description: 'Le nettoyage du patrimoine bâti exige une approche délicate et respectueuse. Nos drones permettent d\'intervenir sur des édifices classés ou inscrits sans contact direct, en adaptant la pression et les produits aux matériaux anciens (pierre calcaire, grès, brique). Une méthode non invasive approuvée par les architectes des bâtiments de France.',
    icon: 'Landmark',
    image: 'https://customer-assets.emergentagent.com/job_af6724b6-14b0-4bf2-bd86-e1555b904131/artifacts/5hyr2hqt_111.jpg',
    benefits: [
      'Respect absolu des matériaux anciens : pierre, brique, enduit historique',
      'Méthode non invasive validée par les architectes des bâtiments de France',
      'Aucun échafaudage sur les façades : préservation de l\'esthétique du monument',
      'Traitement biocide doux compatible avec les contraintes patrimoniales',
      'Documentation photographique HD avant/après pour le suivi patrimonial',
      'Expérience sur églises, châteaux, hôtels particuliers et bâtiments classés'
    ],
    process: [
      'Analyse approfondie des matériaux et concertation avec les autorités patrimoniales',
      'Tests de compatibilité sur une zone témoin avant intervention complète',
      'Nettoyage adapté zone par zone avec pression et produits spécifiques',
      'Documentation photographique complète et rapport pour les archives patrimoniales'
    ]
  },
  {
    id: 'batiments-industriels',
    title: 'Bâtiments industriels & commerciaux',
    slug: 'batiments-industriels',
    description: 'Entrepôts, usines, centres commerciaux, supermarchés : nous assurons le nettoyage complet de vos façades, bardages, toitures et enseignes. Notre intervention par drone permet de traiter de grandes surfaces rapidement, sans perturber votre activité ni mobiliser de moyens d\'accès coûteux.',
    icon: 'Factory',
    image: 'https://customer-assets.emergentagent.com/job_eco-drone-1/artifacts/5s2irl11_lidl.png',
    benefits: [
      'Traitement de grandes surfaces en un temps record (jusqu\'à 2000 m²/jour)',
      'Aucune interruption de votre activité commerciale ou industrielle',
      'Accès aux zones difficiles : toitures plates, bardages en hauteur, enseignes',
      'Conformité aux normes d\'hygiène et de sécurité (HACCP, ISO 14001)',
      'Amélioration de l\'image de marque : façades propres = clients rassurés',
      'Contrats d\'entretien récurrents avec tarifs préférentiels'
    ],
    process: [
      'Évaluation sur site des contraintes (accès, horaires, activité en cours)',
      'Coordination avec votre équipe pour planifier l\'intervention sans impact',
      'Nettoyage haute performance des façades, toitures et zones techniques',
      'Rapport de conformité avec traçabilité complète de l\'intervention'
    ]
  },
  {
    id: 'coproprietes',
    title: 'Copropriétés & immeubles',
    slug: 'coproprietes',
    description: 'Ravalement, nettoyage de façades, entretien des parties communes : notre solution par drone offre aux syndics et gestionnaires une alternative économique et efficace. Sans échafaudage ni nuisances pour les résidents, nous redonnons à votre immeuble un aspect soigné qui valorise le patrimoine de la copropriété.',
    icon: 'Building',
    image: 'https://customer-assets.emergentagent.com/job_eco-drone-1/artifacts/nggw7jdb_immeuble.png',
    benefits: [
      'Valorisation immédiate du patrimoine immobilier de la copropriété',
      'Aucune gêne pour les résidents : pas d\'échafaudage, pas de bruit excessif',
      'Coût réduit de 30% par rapport à un ravalement traditionnel avec échafaudage',
      'Planning flexible adapté aux contraintes du syndic et des copropriétaires',
      'Traitement préventif anti-salissures pour un résultat durable',
      'Présentation en assemblée générale avec devis transparent et détaillé'
    ],
    process: [
      'Réunion de présentation avec le syndic et/ou le conseil syndical',
      'Diagnostic complet de l\'immeuble et planification des interventions',
      'Nettoyage progressif par zones avec protection des ouvertures',
      'Compte-rendu photographique avant/après remis au syndic'
    ]
  }
];

export const stats = [
  { value: '+250', label: 'Clients satisfaits' },
  { value: '100%', label: 'Sans échafaudage' },
  { value: '-30%', label: 'Coûts vs méthodes traditionnelles' },
  { value: '48h', label: 'Délai moyen d\'intervention' }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Analyse du support',
    description: 'Évaluation technique, prise de mesures et identification des contraintes d\'accès.'
  },
  {
    step: 2,
    title: 'Planification & sécurité',
    description: 'Définition du protocole d\'intervention, sécurisation de la zone et coordination.'
  },
  {
    step: 3,
    title: 'Intervention drone',
    description: 'Nettoyage par pulvérisation haute précision avec méthode adaptée au support.'
  },
  {
    step: 4,
    title: 'Contrôle qualité',
    description: 'Vérification du résultat, photos avant/après et recommandations d\'entretien.'
  }
];

export const faqs = [
  {
    question: 'Quelle est la durée d\'une intervention ?',
    answer: 'La durée varie selon la surface et la complexité du site. En moyenne, comptez 2 à 4 heures pour une toiture de copropriété, 1 journée pour des panneaux solaires industriels.'
  },
  {
    question: 'Les drones sont-ils sûrs pour mes installations ?',
    answer: 'Absolument. Nos pilotes sont certifiés et utilisent des drones professionnels équipés de capteurs de sécurité. La pulvérisation est calibrée pour ne pas endommager les surfaces. Une inspection est réalisé avant chaque intervention.'
  },
  {
    question: 'Intervenez-vous en cas de mauvais temps ?',
    answer: 'Pour votre sécurité et la qualité du résultat, nous n\'intervenons pas en cas de vent fort (>40 km/h) ou de pluie. Nous replanifions rapidement l\'intervention.'
  },
  {
    question: 'Faut-il une autorisation spéciale ?',
    answer: 'Pour les sites sensibles (monuments historiques, zones protégées), nous gérons les autorisations nécessaires. Pour les interventions standards, nos pilotes disposent de toutes les certifications.'
  },
  {
    question: 'Quel est le gain de rendement pour les panneaux solaires ?',
    answer: 'Le nettoyage régulier peut améliorer le rendement de 15% à 25% selon l\'encrassement initial. Nous mesurons la performance avant et après intervention.'
  },
  {
    question: 'Proposez-vous des contrats d\'entretien ?',
    answer: 'Oui, nous proposons des contrats annuels ou pluriannuels avec interventions programmées, idéal pour les copropriétés, collectivités et sites industriels.'
  },
  {
    question: 'Puis-je obtenir un devis sans engagement ?',
    answer: 'Bien sûr ! Remplissez notre formulaire en ligne ou contactez-nous directement. Nous vous répondons sous 24h avec un devis détaillé et transparent.'
  },
  {
    question: 'Couvrez-vous toute la France ?',
    answer: 'Oui, nous intervenons sur l\'ensemble du territoire français.'
  }
];

export const testimonials = [
  {
    name: 'M. Dubois',
    role: 'Syndic de copropriété, Paris 15e',
    content: 'Intervention rapide et professionnelle. Les résidents n\'ont même pas été dérangés. Le rapport qualité-prix est excellent.',
    rating: 5
  },
  {
    name: 'Sophie R.',
    role: 'Responsable, ENGIE',
    content: 'Nous faisons appel à PULVISTAR pour l\'entretien de nos parcs solaires. Gains de rendement mesurables et équipe très réactive.',
    rating: 5
  },
  {
    name: 'Franck',
    role: 'Responsable de site, Time Tripper',
    content: 'Prestation impeccable sur le nettoyage de notre bâtiment commercial. Respect total des contraintes patrimoniales.',
    rating: 5
  }
];

export const regions = [
  { name: 'Paris & Île-de-France', slug: 'paris' },
  { name: 'Lyon & Auvergne-Rhône-Alpes', slug: 'lyon' },
  { name: 'Marseille & Provence', slug: 'marseille' },
  { name: 'Bordeaux & Nouvelle-Aquitaine', slug: 'bordeaux' },
  { name: 'Toulouse & Occitanie', slug: 'toulouse' },
  { name: 'Nantes & Pays de la Loire', slug: 'nantes' },
  { name: 'Lille & Hauts-de-France', slug: 'lille' },
  { name: 'Strasbourg & Grand Est', slug: 'strasbourg' }
];
